<template>
	<div class="flip-card-side">
		<block-subcanvas
			v-if="mode === 'edit'"
			:value="parentBlock"
			:blocks="blocks"
			mode="edit"
			@create:draft="$emit('create:draft', $event)"
			:blockVariables="blockVariables"
		/>
		<block-subcanvas-readonly
			v-else
			:blocks="blocks"
			:mode="mode ? mode : 'view'"
			@goToBookmarkTarget="$emit('goToBookmarkTarget', $event)"
			@selectSlideById="$emit('selectSlideById', $event)"
			:blockVariables="blockVariables"
			:subcanvasDelay="subcanvasHasDelay ? cardsDelay : undefined"
		/>

		<v-icon v-if="canShowIcon" class="flip-card-side__icon" :size="icon.sizeInPx" :style="iconStyle">{{
			icon.name
		}}</v-icon>
	</div>
</template>

<script>
import BlockSubcanvas from '../_components/containers/BlockSubcanvas.vue';
import BlockSubcanvasReadonly from '../_components/containers/BlockSubcanvasReadonly.vue';

export default {
	name: 'FlipCardSide',
	props: ['side', 'blocks', 'mode', 'blockVariables', 'parentBlock', 'icon'],
	components: { BlockSubcanvas, BlockSubcanvasReadonly },
	data() {
		return {
			subcanvasHasDelay: false
		};
	},
	computed: {
		iconStyle() {
			return `${this.icon.position}: 0; color: ${this.icon.color}; margin: ${this.icon.paddingInPx}px`;
		},
		canShowIcon() {
			return this.icon.visible;
		}
	}
};
</script>

<style>
.flip-card-side {
	position: relative;
	overflow: hidden;
}

.flip-card-side__icon {
	position: absolute;
	bottom: 0;
}
</style>
